import { Accordion } from "@shared/components/accordion";
import { toFarsiNumber } from "@utils/digits";
import { useState } from "react";
import { FaqsItem } from "../types";

interface Props {
  data: FaqsItem[];
}

const Faqs: React.FC<Props> = ({ data }) => {
  const [isOpen, setOpen] = useState(-1);
  return (
    <div className="mt-6  md:mt-12 px-4 md:px-6   xl:px-0 xl:max-w-[1200px] mx-auto   w-full ">
      <h3 className="lg:headline-xlg headline-lg ">سوالات پرتکرار شما</h3>
      <div className="lg:mt-8 mt-6">
        {data.map((faq, index) => {
          return (
            <div className="mb-4" key={index}>
              <Accordion
                key={index}
                open={isOpen === index}
                title={`${toFarsiNumber(String(index + 1))}. ${faq.question}`}
                openAccordion={(e) => {
                  setOpen(e ? index : -1);
                }}
              >
                <p className="text-justify whitespace-pre-line ">
                  {faq.answer}
                </p>
              </Accordion>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Faqs;
